// extracted by mini-css-extract-plugin
export default {"wrap":"cF-z","fullWidth":"dF-z","hideOnDesktop":"eF-z","content":"fF-z","hasOpenedNav":"gF-z","crumbsList":"hF-z","dropdownsWrap":"iF-z"};